module.exports = {
    
    apiBase: "https://api.banquet.ninja/api/v1"
};


// WEBPACK FOOTER //
// ./app/config/production.js